document.addEventListener("DOMContentLoaded", function() {

    let videos = document.querySelectorAll('.video-gallery .video-block video');
    for(let i = 0; i < videos.length; i++) {
      videos[i].addEventListener("click", function(e) {
        let video = e.target.closest('.video-block').querySelector('video');
        if (video) {
          if (!video.paused) {
            pauseVideo(video);
          }
          else {
            playVideo(video);
          }
        }
      });

      videos[i].addEventListener("ended", (event) => {
        videos[i].closest('.video-block').querySelector('.play-icon').style.opacity = 0;
        stopVideo(videos[i]);
      });
    }

    let videoCarousel = document.querySelector('.video-gallery--mobile__container');
    let touchmoved;

    let mobileVideos = document.querySelectorAll('.video-gallery--mobile .video-block');
    for(let i = 0; i < mobileVideos.length; i++) {
      if(mobileVideos[i].getAttribute('listener') !== 'true') {
        mobileVideos[i].setAttribute('listener', 'true');
        mobileVideos[i].addEventListener('touchmove', function(e) {
          touchmoved = true;
        });

        mobileVideos[i].addEventListener('touchstart', function(e) {
          touchmoved = false;
        });

        mobileVideos[i].addEventListener("touchend", function(e) {
          console.log('TOUCH MOVED', touchmoved);
          if(touchmoved != true) {
            console.log("TAPPED");
            let video = e.target.closest('.video-block').querySelector('video');
            if (video) {
              if (video.paused) {
                playVideo(video);
                video.muted = false;
              }
              else {
                // playVideo(video);
                pauseVideo(video);
              }
            }
          }
        });

        mobileVideos[i].addEventListener("ended", (event) => {
          console.log('VIDEO ENDED');
          mobileVideos[i].closest('.video-block').querySelector('.play-icon').style.opacity = 1;
          stopVideo(mobileVideos[i]);
        });
      }

    }


    function playVideo(video) {
      let videos = document.querySelectorAll('.video-block video');
      for(let i = 0; i < videos.length; i++) {
        pauseVideo(videos[i]);
      }
      video.play();
      video.closest('.video-block').querySelector('.play-icon').style.opacity = 0;
    }


    function pauseVideo(video) {
      video.pause();
      video.closest('.video-block').querySelector('.play-icon').style.opacity = 1;
    }

    function stopVideo(video){
      video.pause();
      video.currentTime = 0;
    }


  function debounce(method, delay) {
    clearTimeout(method._tId);
    method._tId= setTimeout(function(){
        method();
    }, delay);
  }

  function toggleVideo(video) {
    if (video) {
      if (video.paused) {
        playVideo(video);
        video.muted = false;
      }
      else {
        pauseVideo(video);
      }
    }
  }
});

// function toggleVideo(video) {
//   if (video) {
//     if (video.paused) {
//       playVideo(video);
//       video.muted = false;
//     }
//     else {
//       // playVideo(video);
//       pauseVideo(video);
//     }
//   }
// }

// function playVideo(video) {
//   let videos = document.querySelectorAll('.video-block video');
//   for(let i = 0; i < videos.length; i++) {
//     stopVideo(videos[i]);
//   }
//   video.play();
//   video.closest('.video-block').querySelector('.play-icon').style.opacity = 0;
// }


// function pauseVideo(video) {
//   video.pause();
//   video.closest('.video-block').querySelector('.play-icon').style.opacity = 1;
// }

// function stopVideo(video){
//   video.pause();
//   video.currentTime = 0;
// }